import { BCMSCurrency, BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { CardOnFileMerchant, Transaction, TransactionDispute } from "model";
import DisputeTransactionReasonPage from "components/pages/DisputeTransactionPages/DisputeTransactionReasonPage";
import DisputeTransactionReasonView, { getDefaultData } from "components/pages/DisputeTransactionPage/components/DisputeTransactionReasonView";
import DisputeItemServicePage from "components/pages/DisputeTransactionPages/DisputeItemServicePage";

export default function CaptureDisputeGoodsServices(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
        const { branding } = useModel();
    const options = branding.options ?? {};
    
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        transactionID = "5"; // A debit card transaction id.
    }
    const data = BCMSStateManagerCRUD.init(getDefaultData(transactionID))
    .submit();

    return (
        <DisputeItemServicePage data={ data }/>
    );
}